var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinShareIcon = function SvgLinkedinShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.015 7.30412C11.015 5.92189 9.98137 4.80005 8.70841 4.80005C7.43121 4.80005 6.39999 5.92189 6.39999 7.30412C6.39999 8.68636 7.43121 9.8082 8.70841 9.8082C9.98137 9.8082 11.015 8.68636 11.015 7.30412ZM10.6986 25.5999H6.71618V11.7059H10.6986V25.5999ZM17.0085 11.706H13.1945V25.6001H17.1685V18.7284C17.1685 16.9154 17.4842 15.1597 19.5545 15.1597C21.5963 15.1597 21.6217 17.2324 21.6217 18.8434V25.6001H25.6V17.98C25.6 14.2384 24.8553 11.3621 20.8274 11.3621C18.8916 11.3621 17.5938 12.5135 17.0631 13.6058H17.0085V11.706Z",
    fillOpacity: 0.9
  })));
};
export default SvgLinkedinShareIcon;